<template>
  <div v-if="dang" class="cx" role="status" aria-live="polite">
    <div class="cx-dong">
      <span class="cx-quay" />
      <span class="cx-nhan">{{ nhan }}</span>
      <span class="cx-so">{{ giay }}s</span>
    </div>
    <div class="cx-bar"><div class="cx-bar-in" :class="{ 'cx-bar-lau': quaHan }" :style="{ width: phanTram + '%' }" /></div>
    <div class="cx-phu">
      <template v-if="!quaHan">{{ lang('Dự kiến còn khoảng') }} <b>{{ conLai }}s</b>. </template>
      <template v-else>{{ lang('Lâu hơn dự kiến một chút, hệ thống vẫn đang xử lý.') }} </template>
      {{ lang('Vui lòng đợi, đừng bấm lại.') }}
    </div>
  </div>
</template>

<script>
// Khoi "dang cho" co dem giay: nguoi dung thay he thong van chay, khong bam di bam lai.
// `uocTinh` la thoi gian du kien (giay): thanh tien do chay theo no, het gio ma chua xong thi doi
// sang thong bao "lau hon du kien" thay vi dung im o 100%.
export default {
  name: 'ChoXuLy',
  props: {
    dang: { type: Boolean, default: false },
    nhan: { type: String, default: '' },
    uocTinh: { type: Number, default: 20 },
  },
  data() {
    return { giay: 0, hen: null, batDau: 0 }
  },
  computed: {
    conLai() {
      return Math.max(0, this.uocTinh - this.giay)
    },
    quaHan() {
      return this.giay >= this.uocTinh
    },
    phanTram() {
      return this.quaHan ? 100 : Math.max(4, Math.round((this.giay / this.uocTinh) * 100))
    },
  },
  watch: {
    dang: { immediate: true, handler(v) { v ? this.chay() : this.dung() } },
  },
  beforeDestroy() {
    this.dung()
  },
  methods: {
    chay() {
      this.dung()
      this.giay = 0
      this.batDau = Date.now()
      this.hen = setInterval(() => { this.giay = Math.floor((Date.now() - this.batDau) / 1000) }, 500)
    },
    dung() {
      if (this.hen) {
        clearInterval(this.hen)
        this.hen = null
      }
    },
  },
}
</script>

<style scoped>
.cx { background: rgba(47, 128, 255, 0.1); border: 1px solid rgba(47, 128, 255, 0.35); border-radius: 10px; padding: 0.6rem 0.8rem; margin: 0.5rem 0 0.8rem; }
.cx-dong { display: flex; align-items: center; gap: 0.55rem; font-weight: 600; font-size: 0.9rem; }
.cx-nhan { flex: 1; min-width: 0; }
.cx-so { font-variant-numeric: tabular-nums; color: #2f80ff; }
.cx-quay { width: 16px; height: 16px; border-radius: 50%; border: 2px solid rgba(47, 128, 255, 0.3); border-top-color: #2f80ff; animation: cx-xoay 0.8s linear infinite; flex: none; }
@keyframes cx-xoay { to { transform: rotate(360deg); } }
.cx-bar { height: 6px; border-radius: 4px; background: rgba(127, 140, 160, 0.25); overflow: hidden; margin: 0.45rem 0 0.35rem; }
.cx-bar-in { height: 100%; border-radius: 4px; background: linear-gradient(90deg, #2f80ff, #12b5cb); transition: width 0.5s linear; }
.cx-bar-lau { background: linear-gradient(90deg, #ffb020, #ff8a5b); animation: cx-nhap 1.2s ease-in-out infinite; }
@keyframes cx-nhap { 0%, 100% { opacity: 1; } 50% { opacity: 0.55; } }
.cx-phu { font-size: 0.78rem; opacity: 0.8; }
@media (prefers-reduced-motion: reduce) { .cx-quay, .cx-bar-lau { animation: none; } }
</style>
